import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, Instagram, Facebook, Youtube } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-brand-dark text-brand-cream/85 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo_icon.png" alt="E Drives Logo" className="w-8 h-8 object-contain" />
              <span className="text-xl font-bold heading-display text-brand-cream">E Drives</span>
            </Link>
            <p className="mt-4 max-w-md text-sm leading-relaxed">
              One EV platform powering multiple mobility verticals across delivery, campuses and everyday commute.
            </p>
          </div>
          <div>
            <h4 className="text-brand-lime font-semibold mb-4 text-sm">Explore</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-brand-lime">About</Link></li>
              <li><Link to="/mobility-verticals" className="hover:text-brand-lime">Mobility Verticals</Link></li>
              <li><Link to="/host" className="hover:text-brand-lime">Host</Link></li>
              <li><Link to="/#partners" className="hover:text-brand-lime">Ecosystem Partners</Link></li>
              <li><Link to="/contact" className="hover:text-brand-lime">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-brand-lime font-semibold mb-4 text-sm">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Mail size={14} /> 
                <a href="mailto:info@edrives.in" className="hover:text-brand-lime">info@edrives.in</a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={14} /> 
                <a href="tel:+918867208322" className="hover:text-brand-lime">+91-8867208322</a>
              </li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a href="https://www.linkedin.com/company/eco-drives/posts/?feedView=all" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-brand-deep text-brand-cream/80 hover:text-brand-lime hover:bg-brand-deep/80 flex items-center justify-center transition-all duration-200" aria-label="LinkedIn">
                <Linkedin size={15} />
              </a>
              <a href="https://www.instagram.com/edrives.in/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-brand-deep text-brand-cream/80 hover:text-brand-lime hover:bg-brand-deep/80 flex items-center justify-center transition-all duration-200" aria-label="Instagram">
                <Instagram size={15} />
              </a>
              <a href="https://www.facebook.com/ecodrives.in/?view_public_for=1124549377666418" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-brand-deep text-brand-cream/80 hover:text-brand-lime hover:bg-brand-deep/80 flex items-center justify-center transition-all duration-200" aria-label="Facebook">
                <Facebook size={15} />
              </a>
              <a href="https://www.youtube.com/channel/UC-YkDD2sqoIkoWIcY4qgNcg" target="_blank" rel="noopener noreferrer" className="w-8 h-8 rounded-full bg-brand-deep text-brand-cream/80 hover:text-brand-lime hover:bg-brand-deep/80 flex items-center justify-center transition-all duration-200" aria-label="YouTube">
                <Youtube size={15} />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-brand-cream/10 flex flex-col md:flex-row items-center justify-between text-xs text-brand-cream/60">
          <p>© {new Date().getFullYear()} E Drives. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Built for India’s mobility future.</p>
        </div>
      </div>
    </footer>
  );
}
